export const FETCH_TRANSACTIONS_REQUEST = 'FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_FAILED = 'FETCH_TRANSACTIONS_FAILED';

export const FETCH_TRANSACTIONS_BY_ID_REQUEST = 'FETCH_TRANSACTIONS_BY_ID_REQUEST';
export const FETCH_TRANSACTIONS_BY_ID_SUCCESS = 'FETCH_TRANSACTIONS_BY_ID_SUCCESS';
export const FETCH_TRANSACTIONS_BY_ID_FAILED = 'FETCH_TRANSACTIONS_BY_ID_FAILED';
